<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="120px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="考试名称" prop="name">
              <el-input  v-model="formParameter.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="考试类型" prop="type" with="">
              <el-input readonly v-model="examType" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="科 目" prop="sbid">
              <el-input placeholder="请选择科目" disabled v-model="formParameter.sbname">
                <template slot="append">
                  <el-button type="primary" @click="selectSub()"> 选择 </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="考试班级" prop="cid">
              <el-select disabled v-model="formParameter.cid" :clearable="true" :filterable="true" placeholder="请选择班级/可搜索" @change="chgClzz(formParameter.cid)">
                <el-option   v-for="item in listClass" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="formParameter.type == 0" label="考试属性" prop="canScore">
              <el-select v-model="formParameter.canScore">
                <el-option
                  v-for="item in [
                    { id: 0, name: '多选漏选给半分' },
                    { id: 1, name: '多选漏选不给分' }
                  ]"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else-if="formParameter.type == 2" label="面试题数" prop="quenum">
              <el-input v-model="formParameter.quenum" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="考试学生" prop="sid">
              <el-select v-model="formParameter.sid" :clearable="true" :filterable="true" multiple placeholder="请选择学生/可搜索" @change="changeSelect">
                <el-option v-for="item in listStu" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-checkbox v-model="checked" @change="selectAll">全选</el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="试卷名称" prop="expid" with="">
              <el-input readonly v-model="exampaper.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对应科目" prop="sbname">
              <el-input v-model="formParameter.sbname" autocomplete="off" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生效时间" prop="startTime">
              <el-date-picker v-model="formParameter.startTime" type="datetime" placeholder="选择生效时间"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止时间" prop="endTime">
              <el-date-picker v-model="formParameter.endTime" type="datetime" placeholder="选择结束时间"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
         

      
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue'
import api from '@/api/exams/exams/exams.js'
import examApi from '@/api/exams/exampaper/exampaper.js'
import classApi from '@/api/edu/clazz/clazz.js'
import stuapi from '@/api/stus/student/student.js'
import subApi from '@/api/edu/subject/subject.js'

import tree from '@/components/tree/tree.vue'
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue'

export default {
  name: 'edit',
  components: {
    popup,
    tree,
    selectOptionDictionary
  },
  data() {
    return {
      // sbname: '',
      // dialogVisible: false,
      checked: false,
      // permissionList: [],
      subData: [],

      exampaper: {}, //试卷不许改
      examType: '', //考试类型不许改

      listClass: [],
      app: [],
      listStu: [],
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: { type: 0, canScore: 1, sid: [], answer: '', type: 1, isSubjective: 2, reference: '自编题' },
      rules: {
        //学生id
        sid: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ],
        //考试班级id
        cid: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ],
        //生效时间
        startTime: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: 'blur'
          }
        ],
        //截止时间
        endTime: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: 'blur'
          }
        ],
        //考试名称
        name: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    //选择科目
    // treeClick(data) {
    //   this.subData = data
    // },
    // selectSub() {
    //   if (this.permissionList == [] || this.permissionList.length == 0) {
    //     subApi.list({}, response => {
    //       this.permissionList = response.data
    //     })
    //   }
    //   this.dialogVisible = true
    // },
    // comfirmSub() {
    //   this.sbname = this.subData.name
    //   this.formParameter.sbname = this.subData.name
    // },

    selectAll() {
      this.formParameter.sid = []
      if (this.checked) {
        this.listStu.map(item => {
          this.formParameter.sid.push(item)
        })
      } else {
        this.formParameter.sid = []
      }
    },
    changeSelect(val) {
      if (val.length === this.listStu.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.listStu = []
      this.parameter = parameter
      this.disabled = disabled
      this.$refs.popup.open(title, size)
      this.$nextTick(() => {
        this.init()
      })
    },
    //关闭弹框
    close() {
      this.disabled = false
      this.$refs.popup.close()
    },
    //提交表单
    confirm() {
      if (this.formParameter.type == 0) {
        //一般考试
        this.$utils.checkForm(this.$refs.form, () => {
          this.confirmLoading = true
          if (!this.parameter.id) {
            //添加
            let parameter = this.$utils.merger(this.formParameter)
            if (parameter.type == 0) {
              delete parameter.canScore
            } else if (parameter.type == 2) {
              delete parameter.quenum
            } else {
              delete parameter.canScore
              delete parameter.quenum
            }
            api.save(
              parameter,
              response => {
                this.$utils.msg.success(response.msg)
                this.confirmLoading = false
                this.close()
                this.$parent.list()
              },
              response => {
                this.$utils.msg.warning(response.msg)
                this.confirmLoading = false
              }
            )
          } else {
            //编辑
            let parameter = this.$utils.merger(this.formParameter)
            if (parameter.type == 0) {
              delete parameter.canScore
            } else if (parameter.type == 2) {
              delete parameter.quenum
            } else {
              delete parameter.canScore
              delete parameter.quenum
            }
            api.update(
              parameter,
              response => {
                this.$utils.msg.success(response.msg)
                this.confirmLoading = false
                this.close()
                this.$parent.list()
              },
              response => {
                this.$utils.msg.warning(response.msg)
                this.confirmLoading = false
              }
            )
          }
        })
      } else if (this.formParameter == 1) {
        //线下考试
        //  组件间传值 重新弹框  ，配置试卷
      } else {
        // 面试考试
        // 组件间传值 重新弹框  ，配置试卷
      }
    },
    chgClzz(cid) {
      let parameter = {
        cid: cid
      }
      stuapi.stuInClass(parameter, response => {
        this.listStu = response.data
        delete this.formParameter.sid
      })
    },
    init() {
      this.popupLoading = true
      //清除等待
      this.confirmLoading = false
      //清空内容
      this.formParameter = { type: 0, canScore: 1 }
      //清楚校验
      this.$refs.form.clearValidate()

      classApi.selectList({}, response => {
        this.listClass = response.data
      })

      //编辑查询数据
      let parameter = {
        id: this.parameter.id
      }

      api.toUpdate(parameter, response => {
        this.formParameter = response.data

        if (this.formParameter.type == 0) {
          this.examType = '线上考试'
          if(this.formParameter.isMobile){
            this.examType = '线上考试(支持移动端)'
          }
        } else if (this.formParameter.type == 1) {
          this.examType = '线下考试'
        } else if (this.formParameter.type == 2) {
          this.examType = '面试考试'
        } else {
          this.examType = '作业'
        }


        let parameter = {
          cid: this.formParameter.cid
        }
        stuapi.stuInClass(parameter, res => {
          this.listStu = res.data
        })
        //加载考试试卷
        examApi.toUpdate({ id: this.formParameter.expid }, res => {
          this.exampaper = res.data
        })
        this.formParameter.sid = JSON.parse(response.data.sid)
        this.popupLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
